import {forwardRef, useImperativeHandle, useState} from "react"
import {customerAPI} from "@indebted/api/customerAPI"
import {Box, Checkbox, Link} from "@mui/material"
import {Trans} from "react-i18next"
import {styled} from "@mui/material/styles"

export const ESignConsentIfNeeded = forwardRef(
	(
		{
			RequestESIGNConsent,
			SecureCode,
			CustomerID,
		}: {RequestESIGNConsent: boolean; SecureCode: string; CustomerID: string},
		ref,
	) => {
		const [esignConsentEnabled, setESIGNConsentEnabled] = useState(false)
		const [showESIGNErrorMessage, setShowESIGNErrorMessage] = useState(false)
		const [hasGrantedESIGNConsent, setHasGrantedESIGNConsent] = useState(false)

		const onChangeESIGNConsentCheckbox = (checked: boolean) => {
			setESIGNConsentEnabled(checked)
			setShowESIGNErrorMessage(!checked)
		}

		useImperativeHandle(ref, () => {
			return {
				validate: () => {
					if (RequestESIGNConsent && !esignConsentEnabled && !hasGrantedESIGNConsent) {
						setShowESIGNErrorMessage(true)
						return false
					}
					return true
				},
				submit: async () => {
					if (RequestESIGNConsent && esignConsentEnabled && !hasGrantedESIGNConsent) {
						await customerAPI.grantESIGNConsent({customerID: CustomerID})
						setHasGrantedESIGNConsent(true)
					}
				},
			}
		})

		if (!RequestESIGNConsent) {
			return null
		}

		return (
			<>
				<Box
					display="flex"
					flexDirection="row"
					justifyContent="flex-start"
					alignItems="flex-start"
					gap={0}
					paddingTop="1rem"
				>
					<Checkbox
						sx={{
							marginTop: "-9px",
						}}
						disabled={hasGrantedESIGNConsent}
						checked={esignConsentEnabled || hasGrantedESIGNConsent}
						onChange={(e) => onChangeESIGNConsentCheckbox(e.target.checked)}
						name="esign-consent"
						color="primary"
						id="esign-consent"
					/>
					<Label htmlFor="esign-consent" style={{paddingBottom: "0"}}>
						<Trans i18nKey="payment_arrangement.esign.checkbox_text" components={{a: <Link />}} />
					</Label>
				</Box>
				{showESIGNErrorMessage && (
					<Box paddingTop="0.5rem">
						<StyledAlertGrid>
							<Trans
								i18nKey="payment_arrangement.esign.error_message"
								components={{a: <Link />}}
								values={{SecureCode}}
							/>
						</StyledAlertGrid>
					</Box>
				)}
			</>
		)
	},
)

const StyledAlertGrid = styled(Box)`
	border: solid 1px #d7153a;
	border-radius: 5px;
	padding: 0.5rem;
	color: #d7153a;

	p {
		font-size: 0.75rem;
		color: #d7153a;
	}
`
const Label = styled("label")`
	color: #737373;
	font-size: 0.875rem;
	font-style: normal;
	font-weight: 500;
	line-height: 1.25rem; /* 142.857% */
	letter-spacing: 0rem;
	display: block;
	padding-bottom: 0.5rem;
`
